function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.93359 16.4844H13.7227V17.6562H4.93359V16.4844Z",
  fill: "#23335B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.93359 14.1406H13.7227V15.3125H4.93359V14.1406Z",
  fill: "#23335B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.93359 11.7969H13.7227V12.9688H4.93359V11.7969Z",
  fill: "#23335B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4102 0H4.93359V2.34375H2.58984V20H16.0664V17.6562H18.4102V0ZM14.8945 18.8281H3.76172V3.51562H6.98438C7.95363 3.51562 8.74219 4.30418 8.74219 5.27344V9.66797H13.1367C14.106 9.66797 14.8945 10.4565 14.8945 11.4258V18.8281ZM12.693 8.49609H9.91406V5.71719L12.693 8.49609ZM17.2383 16.4844H16.0664V11.4258C16.0664 10.6181 15.7379 9.88566 15.2073 9.35516C15.2083 9.35418 9.05598 3.20184 9.05598 3.20184C8.52449 2.6723 7.79207 2.34375 6.98438 2.34375H6.10547V1.17188H17.2383V16.4844Z",
  fill: "#23335B"
});

var SvgOrgPatientInfo = function SvgOrgPatientInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrgPatientInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/org-patient-info.12931e58.svg";
export { ForwardRef as ReactComponent };